import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import FieldModal from 'modules/custom_resources/components/CustomFields/FieldModal'
import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'

type FieldModalProps = React.ComponentProps<typeof FieldModal>

interface Props {
  onClose: FieldModalProps['onClose']
  onSubmit: FieldModalProps['onSubmit']
}

export default function NewQuestionConfigModal({ onClose, onSubmit }: Props) {
  return (
    <FieldModal
      modalIllustration="server-edit"
      modalTitle={i18n.t('surveys.form.question_configs.new.title')}
      modalDescription={i18n.t('surveys.form.question_configs.new.description')}
      modalLabel={i18n.t('surveys.form.question_configs.new.label')}
      modalPlaceholder={i18n.t('surveys.form.question_configs.new.label_placeholder')}
      modalButton={i18n.t('surveys.form.question_configs.new.submit')}
      allowPermissions={false}
      showAllowedFieldTypes
      allowedFieldTypes={[
        FieldTypes.text,
        FieldTypes.singleChoice,
        FieldTypes.rating,
        FieldTypes.cents,
      ]}
      showRequired
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}
